import * as yup from "yup";

export function localDateYmd(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export const TELEHEALTH_TIME_SLOT_OPTIONS = [
  // "2:00 AM",
  // "2:30 AM",
  // "3:00 AM",
  // "3:30 AM",
  // "4:00 AM",
  // "4:30 AM",
  // "5:00 AM",
  // "5:30 AM",
  // "6:00 AM",
  // "6:30 AM",
  // "7:00 AM",
  // "7:30 AM",
  // "08:00 AM",
  // "08:30 AM",
  "09:00 AM",
  "09:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "01:00 PM",
  "01:30 PM",
  "02:00 PM",
  "02:30 PM",
  "03:00 PM",
  "03:30 PM",
  "04:00 PM",
  "04:30 PM",
  "05:00 PM",
  "05:30 PM",
].map((start, index, starts) => {
  const end = starts[index + 1] ?? "06:00 PM";
  const range = `${start} - ${end}`;
  return { label: `${range} (30 min)`, value: range };
});

export const scheduleTelehealthInitialValues = {
  assignedProvider: "",
  sendNotification: "yes",
  appointmentDate: "",
  timeSlot: "10:30 AM - 11:00 AM",
  clinicalNotes: "",
};

export const scheduleTelehealthSchema = yup.object({
  assignedProvider: yup.string().required("Assigned provider is required"),
  sendNotification: yup.string().oneOf(["yes", "no"]).required("Send notification is required"),
  appointmentDate: yup
    .string()
    .required("Appointment date is required")
    .test("not-past", "Appointment date must be today or a future date", (value) => {
      if (!value) return true;
      return value >= localDateYmd();
    }),
  timeSlot: yup.string().required("Time slot is required"),
  clinicalNotes: yup.string().trim().required("Clinical visit notes are required"),
  informedParties: yup
    .boolean()
    .oneOf([true], "Required")
    .required("Required"),
  bookedOnProviderCalendar: yup
    .boolean()
    .oneOf([true], "Required")
    .required("Required"),
});
